import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Chip from '~/components/base/Chip';
import Image from '~/components/base/Image';

import { h3, h4, p } from '~/styles/typography';
import { checkbox, radio } from '~/styles/forms';

import { formatText } from '~/utilities/helpers';

const Card = styled.label`
    display: flex;
    flex-direction: column;
    background-color: white;
    padding: 25px 30px;
    box-shadow: 0 2px 4px 3px rgba(0, 0, 0, 0.2);
    border-radius: 14px;
    cursor: pointer;
`;

const TopWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 35px;
`;

const BottomWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
`;

const Title = styled.h3`
    ${({ largeTitle }) => (largeTitle ? h3 : h4)};
    font-weight: ${({ theme }) => theme.fontWeights.black};
`;

const Description = styled.div`
    ${p};
    margin-top: 20px;
`;

const Input = styled.input`
    ${({ type }) => (type === 'checkbox' ? checkbox : radio)};
`;

const BottomText = styled.p`
    ${h4};
    padding-top: 15px;
    margin-top: auto;
`;

const StyledImage = styled(Image)`
    flex: 1 1 100%;
    @media (min-width: ${({ theme }) => theme.breakpoint.largeTablet}) {
        flex: 0 1 33%;
    }
`;

const ModalCard = ({
    title,
    description,
    chipText = '',
    bottomText = '',
    largeTitle = false,
    inputType = 'radio',
    inputName,
    image = '',
    className = '',
    ...props
}) => {
    return (
        <Card {...{ className }}>
            <TopWrapper>
                <Input type={inputType} name={inputName} {...props} />
                {chipText && <Chip>{chipText}</Chip>}
            </TopWrapper>
            <BottomWrapper>
                <div>
                    <Title {...{ largeTitle }}>{formatText(title)}</Title>
                    <Description>{formatText(description)}</Description>
                </div>
                {image && (
                    <StyledImage objectFit="contain" sourceUrl={image} alt="" />
                )}
            </BottomWrapper>
            {bottomText && <BottomText>{bottomText}</BottomText>}
        </Card>
    );
};

ModalCard.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    chipText: PropTypes.string,
    bottomText: PropTypes.string,
    largeTitle: PropTypes.bool,
    inputType: PropTypes.oneOf(['checkbox', 'radio']),
    inputName: PropTypes.string.isRequired,
    image: PropTypes.string,
    className: PropTypes.string
};

export default ModalCard;
